import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';
import { useTheme } from 'lib/context/ThemeContext';
import { GetStaticComponentProps, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import Component from 'src/helpers/Component/Component';
import { HelpfulLinksTheme } from './HelpfulLinks.theme';
import Headline from 'src/helpers/Headline/Headline';
import { getHeadingLevel } from 'lib/utils';
import SingleButton from 'src/helpers/SingleButton/SingleButton';
import { mapItemFieldResultsToObject } from 'lib/graphql/mappers/map-item-field-results-to-object';
import { mapSearchResults } from 'lib/graphql/mappers/map-search-results';
import { IntegratedGraphQlResult } from 'lib/graphql/types/integrated-graphql-result';
import { ItemFieldResult } from 'lib/graphql/types/item-field-result';
import { ItemSearchResults } from 'lib/graphql/types/item-search-results';

export type HelpfulLinksProps =
  Feature.EnterpriseWeb.Enterprise.Components.General.HelpfulLinks.HelpfulLinks;
const HelpfulLinks = (props: HelpfulLinksProps) => {
  const { themeData } = useTheme(HelpfulLinksTheme);
  const defaultTag = 'h2';
  const tag = getHeadingLevel(defaultTag, props?.fields?.headlineLevel);

  return (
    <Component variant="full" dataComponent="general/helpfullinks" {...props}>
      <div className={themeData.classes.container}>
        <Headline useTag={tag} classes={themeData.classes.headlineClass} {...props} />
        <div className={themeData.classes.wrapper}>
          {props.fields?.children?.map((_item: HelpfulLinksProps, i: number) => {
            return (
              <div key={i} className="mb-xxs md:mb-0">
                <SingleButton
                  classes={
                    (themeData.classes.linkClasses,
                    { cta1Classes: '!whitespace-pre-wrap !leading-ml !text-text-link' })
                  }
                  fields={{
                    cta1Link: _item?.fields?.ctaLink,
                    cta1AriaLabel: {
                      value: '',
                    },
                    cta1ModalLinkText: {
                      value: '',
                    },
                    cta1Style: {
                      id: '',
                      url: '',
                      name: 'Link',
                      displayName: 'Link',
                      fields: {
                        Value: {
                          value: 'link',
                        },
                      },
                      templateId: '',
                      templateName: 'Enum',
                    },
                    cta1Icon: {
                      id: '',
                      url: '',
                      name: 'Arrow',
                      displayName: 'Arrow',
                      fields: {
                        Value: {
                          value: 'arrow',
                        },
                      },
                      templateId: '',
                      templateName: 'Enum',
                    },
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </Component>
  );
};
type IntegratedGraphQl = IntegratedGraphQlResult<{
  item: {
    fields: ItemFieldResult[];
    children: ItemSearchResults<{
      template: { name: string };
      fields: ItemFieldResult[];
    }>;
  };
}>;
export const getStaticProps: GetStaticComponentProps = async (rendering) => {
  if (rendering.fields === undefined || !('data' in rendering.fields)) {
    return {};
  }

  const fields = rendering.fields as unknown as IntegratedGraphQl;

  const result = {
    fields: {
      ...mapItemFieldResultsToObject(fields.data.item.fields),
      children: mapSearchResults(fields.data.item.children, (child) => ({
        fields: {
          ...mapItemFieldResultsToObject(child.fields),
        },
      })),
    },
  };
  return result;
};
export default withDatasourceCheck()<HelpfulLinksProps>(HelpfulLinks);
